// extracted by mini-css-extract-plugin
export var button = "_mm-2";
export var card = "_mm-0";
export var closeButtonContainer = "_mm-3";
export var iconContainer = "_mm-1";